module.exports = __webpack_public_path__ + "static/media/painter.1cc4a965.png";